<template>
  <div
      class="agent-item d-flex align-center justify-space-between"
      :class="{
      'agent-item--selected': selected,
      'agent-item--editable': editable,
      'agent-item--inactive': inactive,
      'cursor-pointer': cursorPointer,
    }"
      @click="$emit('click')"
  >
    <!-- LEFT -->
    <div class="d-flex align-center">
      <div class="agent-item__icon mr-2" :class="{ 'agent-item__icon--active': selected}">
        <v-icon small :class="{ 'agent-item__icon--active': selected}">
          mdi-face-agent
        </v-icon>
      </div>

      <div class="agent-item__content">
        <div class="agent-item__name font-weight-medium">
          {{ fullName || infos.email }}
        </div>
        <div v-if="infos.email && fullName" class="agent-item__email grey--text text--darken-2">
          {{ infos.email }}
        </div>
      </div>
    </div>

    <!-- RIGHT -->
    <v-btn
        v-if="destructible"
        icon
        x-small
        @click.stop="$emit('delete')"
    >
      <v-icon small>mdi-close</v-icon>
    </v-btn>
  </div>
</template>


<script>
export default {
  name: "WorkshopContactCard",
  props: {
    infos:  { type: Object, default: () => ({firstname: "", lastname: "", email: ""}) },
    selected: { type: Boolean, default: false },
    editable: { type: Boolean, default: false },
    destructible: { type: Boolean, default: false },
    active: { type: Boolean, default: true },
    cursorPointer: { type: Boolean, default: false },
  },
  emits: ["click", "delete"],
  computed: {
    fullName() {
      return [this.infos.firstname, this.infos.lastname]
          .filter(Boolean)
          .join(' ')
    },
    inactive() {
      return !this.$props.active
    }
  }
}
</script>


<style scoped>


/* Card content */
.agent-item {
  border: 1px solid #EEEEEE;
  padding: 6px 8px;
  margin-bottom: 8px;
  border-radius: 8px;
}

.agent-item__icon {
  width: 24px;
  height: 24px;
  min-width: 24px;
  border-radius: 999px;
  border: 1px solid #dadce0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.agent-item__icon--active {
  color: #FB8C00;
  border-color: #FB8C00;
}

.agent-item__icon--active .v-icon {
  color: #FB8C00;
  border-color: #FB8C00;
}


.agent-item__name, .agent-item__email {
  line-height: 1.2;
  word-break: break-word;
}
.agent-item__name {
  font-size: 12px;
}
.agent-item__email {
  font-size: 10px;
}

/* Card states */
.agent-item--editable:hover {
  border-color: #BDBDBD;
}

.agent-item--selected {
  border-color: #FB8C00;
  background: #FFF3E0;
}

.agent-item--inactive {
  opacity: 0.6;
  border-style: dashed !important;
}

</style>